import React, {Component} from 'react';
import {Link} from 'react-router-dom';
import {Grid} from 'react-bootstrap';

import {Wrapper} from 'system/wrapper';
import Breadcrumbs from '../../breadcrumbs';
import {Image} from '../components';

import departmentStructure from 'images/general/departmentStructure.png';

class Units extends Component {
  render() {
    return (
      <div>
        <Breadcrumbs>
          <li><Link to="/">Головна</Link></li>
          <li><Link to="/health-management">Департамент охорони здоров’я</Link></li>
          <li><Link to="/health-management/units  ">Підрозділи</Link></li>
        </Breadcrumbs>
        <Wrapper>
          <Grid>
            <h2>Підрозділи / відділи</h2>
            <Image>
              <img src={departmentStructure} alt="ad"></img>
            </Image>
          </Grid>
        </Wrapper>
      </div>
    )
  }
}

export default Units;



// WEBPACK FOOTER //
// ./src/system/management/units/index.js